module.exports = __webpack_public_path__ + "/build/web/images/testimonials-right-2.c8a7b8c561b75564294696d8f0e83b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-right-2.jpg
// module id = 203
// module chunks = 13